// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"338":"060787d11cea7316","699":"532c6f4d698804fc"}[chunkId] + ".css";
};